import { createAction, props } from '@ngrx/store';

export const loadPermissions = createAction('[Authorization] Load Permissions');
export const loadPermissionsSuccess = createAction(
  '[Authorization] Load Permissions Success',
  props<{ permissions: string[] }>()
);
export const loadPermissionsFailure = createAction(
  '[Authorization] Load Permissions Failure',
  props<{ error: any }>()
);
